import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetCentroCustoRestricaoUsuarioUseCase } from "../../../presentation/useCases/read/get_centro_custo_restricao_usuario_use_case";
import { CentroCustoRestricaoUsuario } from "../../models/centro_custo_restricao_usuario";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetCentroCustoRestricaoUsuarioUseCase
 */

export class GetCentroCustoRestricaoUsuarioUseCase extends BasePaginatedUseCase<CentroCustoRestricaoUsuario>
  implements IGetCentroCustoRestricaoUsuarioUseCase {
  constructor(private readonly repository: IAdministracaoRepository) {
    super();
  }

  async execute(
    page?: number,
    rowsPerPage?: number
  ): Promise<void> {

    const request = await this.repository.getCentroCustoRestricoesUsuario(
      page ?? 1,
      rowsPerPage ?? 100,
    );

    const normalizedItems: CentroCustoRestricaoUsuario[] = request.items.map((item) => ({
      idCentroCusto: item.idCentroCusto ?? 0,
      codigo: item.codigo ?? '-',
      descricao: item.descricao ?? undefined,
    }));

    this._items = normalizedItems;
    this._totalItems = request.totalItems;
    this._currentPage = request.currentPage;
    this._pageSize = request.pageSize;
    this._totalPages = request.totalPages;

  }
}
